import { render, staticRenderFns } from "./GoodsPickers.vue?vue&type=template&id=4762c705&scoped=true&"
import script from "./GoodsPickers.vue?vue&type=script&lang=js&"
export * from "./GoodsPickers.vue?vue&type=script&lang=js&"
import style0 from "./GoodsPickers.vue?vue&type=style&index=0&id=4762c705&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4762c705",
  null
  
)

export default component.exports